import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';

type Theme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly key = 'atlas-portal-theme';
  readonly theme = signal<Theme>(this.readTheme());

  constructor() {
    this.apply();
  }

  toggle(): void {
    this.theme.update((theme) => theme === 'light' ? 'dark' : 'light');
    this.apply();
    try {
      this.document.defaultView?.localStorage.setItem(this.key, this.theme());
    } catch { /* The theme also works when browser storage is unavailable. */ }
  }

  private readTheme(): Theme {
    try {
      return this.document.defaultView?.localStorage.getItem(this.key) === 'dark' ? 'dark' : 'light';
    } catch {
      return 'light';
    }
  }

  private apply(): void {
    this.document.documentElement.dataset['theme'] = this.theme();
    this.document.documentElement.style.colorScheme = this.theme();
  }
}
